export default __webpack_public_path__ + "static/media/smardtv_logo.97824286.png";